import React, { useState } from "react";
import BusinessForm from "./BusinessForm";
import { ProfileData } from "../types/profile";
import { useBusinessForm } from "../hooks/useBusinessForm";
import api from "../../../../features/auth/axiosConfig";
import { notifyError, notifySuccess } from "../../../../assets/toastService";
import { ModalWrapper } from "../../../components/ModalWrapper";
import CommonButtons from "../../../../shared/components/CommonButtons";

interface EditBusinessProps {
  profileData: ProfileData | null;
  onClose: () => void;
  onSave: () => void;
}

const EditBusiness: React.FC<EditBusinessProps> = ({ profileData, onClose, onSave }) => {
  const { formData, handleChange ,setFormData  } = useBusinessForm(profileData);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!profileData) return;

    if (!formData.email_id.trim()) {
      notifyError("Email ID is required.");
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(co|com)$/i;

    if (!emailRegex.test(formData.email_id)) {
      notifyError("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const updates = {
        ...formData,
        time_zone: formData.time_zone ? Number(formData.time_zone) : null,
      };

      await api.put(`/pos/profile/${profileData._id.$oid}`, updates, {
        headers: { "Content-Type": "application/json" },
      });

      notifySuccess("Business profile updated successfully!");

      // ✅ Keep button disabled until modal closes
      setTimeout(() => {
        onSave();
        onClose();
        setLoading(false); // move here
      }, 1000);
    } catch (error) {
      console.error("Error updating business profile:", error);
      notifyError("Failed to update business profile. Please try again.");
      setLoading(false); // only re-enable if error
    }
  };

  if (!profileData) return null;

  return (
    <ModalWrapper title="Edit Business Profile" useTheme={true} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <BusinessForm formData={formData} handleChange={handleChange} setFormData={setFormData} />

        <div className="flex justify-end gap-3 pt-2">
          <CommonButtons className="w-36" label="CANCEL" variant="outlineDanger" onClick={onClose} type="button" />
          <CommonButtons className="w-36" label={loading ? "Saving..." : "Confirm"} disabled={loading} type="submit" />
        </div>
      </form>
    </ModalWrapper>
  );
};

export default EditBusiness;
